import * as yup from "yup";
import { PaymentMethod } from "./PaymentMethod.ts";
import {
  HeyLightConfigDTO,
  PaymentMethodConfig,
} from "./PaymentMethodConfiguration.ts";
import { HeyLightConfigFields } from "./HeyLightConfigurationFields.tsx";

const heylightValidationSchema = yup.object({
  successUrl: yup
    .string()
    .url("URL non valido")
    .required("URL di successo obbligatorio per HeyLight"),
  failureUrl: yup
    .string()
    .url("URL non valido")
    .required("URL di fallimento obbligatorio per HeyLight"),
  allowedTerms: yup
    .array()
    .of(yup.number().required())
    .min(1, "Devi selezionare almeno un numero di rate")
    .required("Numero di rate obbligatorio"),
});

export const HeyLightPaymentMethodConfig: PaymentMethodConfig<HeyLightConfigDTO> =
  {
    method: PaymentMethod.HeyLight,
    configFieldName: "heylightConfig",
    validationSchema: heylightValidationSchema,
    ConfigComponent: HeyLightConfigFields,
    defaultValues: {
      successUrl: "",
      failureUrl: "",
      allowedTerms: [6, 12, 18],
    },
  };
